jQuery(($) => {
    if ($(".m-triggered-video-player")[0]) {
        const players = Array.from(document.querySelectorAll('.m-triggered-video-player__video'));
 
        $('.m-triggered-video-player .js-trigger-video').click(function () {

            var parent = $(this).parent();
 
            parent.addClass('m-triggered-video-player--playing');

            players.map(player => new Plyr(player, {
                type: 'video',
                autoplay: false,
                controls: ['play', 'current-time', 'progress', 'duration', 'mute', 'volume', 'pip', 'fullscreen', 'airplay'],
                loadSprite: false,
                ratio: '793:446',
                fullscreen: {
                    enabled: true, 
                    fallback: true,
                    iosNative: true,
                    container: null
                }
            }));

            if (players) players[0].play();

        });
    }
});